import store from '@/store'

export default class ChatLogApi {
  static async createChatLog (payload) {
    return await store.dispatch('chatLog/createChatLog', payload)
  }

  static async getChatLog (payload) {
    return await store.dispatch('chatLog/listChatLog', payload)
  }

  static async clearChatLog (payload) {
    return await store.dispatch('chatLog/clearChatLog', payload)
  }
}
